module.exports = __webpack_public_path__ + "img/model_33_border1.efbf1e83.png";